import {
  CalendarEventResponseStatus,
  ExternalCalendarEvent,
  ExternalEventResponseState,
} from '@griply/types';

const RESPONSE_STATES: Record<
  CalendarEventResponseStatus,
  ExternalEventResponseState
> = {
  [CalendarEventResponseStatus.NeedsAction]:
    ExternalEventResponseState.AwaitingResponse,
  [CalendarEventResponseStatus.Tentative]: ExternalEventResponseState.Tentative,
  [CalendarEventResponseStatus.Accepted]: ExternalEventResponseState.Responded,
  [CalendarEventResponseStatus.Declined]: ExternalEventResponseState.Responded,
};

// The events list has no converter, so this is the seam that absorbs a newer backend's status.
export const getExternalEventResponseState = (
  event: ExternalCalendarEvent,
): ExternalEventResponseState =>
  RESPONSE_STATES[event.selfResponseStatus as CalendarEventResponseStatus] ??
  ExternalEventResponseState.Responded;
